var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLakers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.4066V29.5C5 29.7761 5.22386 30 5.5 30H26.5C26.7761 30 27 29.7761 27 29.5V13.5164C27 13.2403 26.7747 13.0203 26.5006 12.9866C23.9822 12.6772 23.3333 10.0366 23.3333 8.88525V2.5C23.3333 2.22386 23.1095 2 22.8333 2H20.8737C20.6942 2 20.5288 2.09579 20.4431 2.25356C19.8335 3.37579 18.8865 5.21311 16 5.21311C13.9588 5.21311 12.2859 3.36917 11.5669 2.24751C11.47 2.09636 11.3058 2 11.1263 2H9.16667C8.89052 2 8.66667 2.22292 8.66667 2.49906V8.88525C8.66667 11.2142 6.65995 12.463 5.3738 12.9047C5.15687 12.9792 5 13.1773 5 13.4066Z",
    fill: "#1D428A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M5 13.4066V29.5C5 29.7761 5.22386 30 5.5 30H13.5C13.7761 30 14 29.7761 14 29.5V16V5.70875C14 5.70875 14 6 12.5 4.5C11.6257 3.6257 11.261 2.92126 11.1089 2.4857C11.0178 2.22501 10.7761 2 10.5 2H9.16667C8.89052 2 8.66667 2.22292 8.66667 2.49906V8.88525C8.66667 11.2142 6.65995 12.463 5.3738 12.9047C5.15687 12.9792 5 13.1773 5 13.4066Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 16,
    fill: "#FFC72C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 1,
    height: 17,
    fill: "#FFC72C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23C18.5376 23 21 20.5376 21 17.5C21 14.4624 18.5376 12 15.5 12C12.4624 12 10 14.4624 10 17.5C10 20.5376 12.4624 23 15.5 23Z",
    fill: "#244789",
    stroke: "#244789",
    strokeWidth: 0.269423
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5003 22.5218C18.2737 22.5218 20.522 20.2735 20.522 17.5001C20.522 14.7266 18.2737 12.4783 15.5003 12.4783C12.7268 12.4783 10.4785 14.7266 10.4785 17.5001C10.4785 20.2735 12.7268 22.5218 15.5003 22.5218Z",
    fill: "#244789",
    stroke: "#FBAE2E",
    strokeWidth: 0.516393
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9082 19.452L13.4559 15.3521L20.0841 19.452",
    stroke: "#FBAE2E",
    strokeWidth: 0.516393
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1064 15.5876H14.063V22.2832L13.1064 21.805V15.5876Z",
    fill: "#FBAE2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5454 16.0652H15.0237V22.6163L14.5454 22.2826V16.0652Z",
    fill: "#FBAE2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1528 17.0225H12.6311V21.3268L12.1528 21.0194V17.0225Z",
    fill: "#FBAE2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4985 16.7001L15.9768 17.0221V22.6385L15.4985 22.3513V16.7001Z",
    fill: "#FBAE2E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4556 17.2922L16.9338 17.4996V22.2822L16.4556 22.5413V17.2922Z",
    fill: "#FBAE2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.416 17.9786H17.8943V22.0839L17.416 21.9755V17.9786Z",
    fill: "#FBAE2E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.373 18.4561H18.8513V21.3257L18.373 21.7392V18.4561Z",
    fill: "#FBAE2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 29.5V13.4066C5.50002 13.4066 5.50005 13.4065 5.50011 13.4063C5.50037 13.4055 5.50134 13.4032 5.50399 13.3997C5.50978 13.392 5.52074 13.3829 5.5362 13.3776C6.87916 12.9164 9.16667 11.5488 9.16667 8.88525L9.16667 2.5H11.1263L11.1268 2.50009C11.1273 2.50022 11.1285 2.50063 11.1305 2.50173C11.1345 2.50404 11.1406 2.50891 11.146 2.51734C11.529 3.1149 12.1626 3.90128 12.9783 4.54372C13.7918 5.18457 14.827 5.71311 16 5.71311C17.5632 5.71311 18.6405 5.21048 19.4078 4.52768C20.1256 3.88883 20.5474 3.11052 20.8445 2.56229C20.8559 2.54118 20.8672 2.52041 20.8782 2.5H22.8333V8.88525C22.8333 9.53274 23.0113 10.5684 23.5374 11.498C24.0728 12.4437 24.9872 13.3045 26.4397 13.4829C26.4637 13.4858 26.483 13.4971 26.4936 13.5081C26.4979 13.5125 26.4995 13.5156 26.5 13.5166V29.5H5.5Z",
    stroke: "#001058"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLakers);
export default __webpack_public_path__ + "static/media/lakers.93afd64d3ba42e17e2849a6013f20629.svg";
export { ForwardRef as ReactComponent };